import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "./Header";
import Footer from "./Footer";

import HomePage from "../../components/user/HomePage";
import Search from "../../components/user/Search";
import Read from "../../components/user/Read";
import HeroSection from "../../components/user/components/HeroSection";
import PageTitle from "../../components/user/components/PageTitle";
import Page404 from "../../components/user/Page404";

import PhotoNewsSection from "../../components/user/components/PhotoNewsSection";
import FeaturedSection from "../../components/user/components/FeaturedSection";
import Youtube from "../../components/user/components/Youtube";
import ClientsSection from "../../components/user/components/ClientsSection";
/*                                */
/* This is the webpage header CSS */
/*                                */

//import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";
// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// AOS
import AOS from "aos";
import "aos/dist/aos.css";

// Vendor CSS
import "../../assets/vendor/glightbox/css/glightbox.min.css";
import "../../assets/vendor/swiper/swiper-bundle.min.css";

// Custom CSS
import "../../assets/css/main.css";
import "../../assets/css/custom.css";


function MasterUserwebpage(props) {
  const { section, id } = useParams();

  /*                                */
  /* This is the webpage header JS  */
  /*                                */

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 600,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });

    // Dynamically load scripts
    const loadScript = (src) => {
      return new Promise((resolve) => {
        // Prevent duplicate loading
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }

        const script = document.createElement("script");
        script.src = src;
        script.async = true;

        script.onload = () => resolve();

        document.body.appendChild(script);
      });
    };

    const loadScripts = async () => {
      // Load sequentially from (public)
      await loadScript("/assets/vendor/purecounter/purecounter_vanilla.js");

      await loadScript("/assets/vendor/glightbox/js/glightbox.min.js");

      await loadScript("/assets/vendor/imagesloaded/imagesloaded.pkgd.min.js");

      await loadScript("/assets/vendor/isotope-layout/isotope.pkgd.min.js");

      await loadScript("/assets/js/main.js");

      // Initialize GLightbox safely
      if (typeof window.GLightbox !== "undefined") {
        window.GLightbox({
          selector: ".glightbox",
        });
      }

      // Initialize PureCounter safely
      if (typeof window.PureCounter !== "undefined") {
        new window.PureCounter();
      }
    };

    loadScripts();
  }, []);

  /*                                    */
  /* End This is the webpage header JS  */
  /*                                    */

  useEffect(() => {
    const updateHeaderHeight = () => {
      const header = document.getElementById("header");

      if (header) {
        document.documentElement.style.setProperty(
          "--header-height",
          `${header.offsetHeight}px`,
        );
      }
    };

    updateHeaderHeight();

    window.addEventListener("resize", updateHeaderHeight);

    return () => {
      window.removeEventListener("resize", updateHeaderHeight);
    };
  }, []);

  const isHome =
    (section === "Home" || section === undefined) &&
    props.name !== "Page404" &&
    props.name !== "Search" &&
    props.name !== "Read";

  let tagName;

  switch (props.name) {
    case "HomePage":
      tagName = <HomePage />;
      break;

    case "Read":
      tagName = <Read />;
      break;

    case "Search":
      tagName = <Search />;
      break;

    case "Page404":
      tagName = <Page404 />;
      break;

    default:
      tagName = <Page404 />;
  }

  return (
    <div className="layout-wrapper">
      <header id="header" className="header sticky-top">
        <Header />
      </header>

      <main className="main" style={{ minHeight: "100vh" }}>
        {isHome && <HeroSection />}

        <PageTitle section={section} />

        {tagName}
      </main>

      {(section != "Photo Gallery" || Number(id) != 12) && <PhotoNewsSection />}
      {isHome && <FeaturedSection />}
      <Youtube />

      <ClientsSection />

      <footer id="footer" className="footer">
        <Footer />
      </footer>
      {/* Scroll Top */}
      <Link
        to="#"
        id="scroll-top"
        className="scroll-top d-flex align-items-center justify-content-center"
      >
        <i className="fa-solid fa-arrow-up"></i>
      </Link>
    </div>
  );
}

export default MasterUserwebpage;
